import { render } from "./RecommendationAssignments.vue?vue&type=template&id=7922ad20&scoped=true"
import script from "./RecommendationAssignments.vue?vue&type=script&lang=js"
export * from "./RecommendationAssignments.vue?vue&type=script&lang=js"

import "./RecommendationAssignments.vue?vue&type=style&index=0&id=7922ad20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7922ad20"]])

export default __exports__